import { Children, type ReactNode } from 'react'
import { useRightPanel } from '@/containers/SubscriptionFormPageNew/Components/shared/RightPanel/rightPanelContext'

// Folded panel: only the first child, the heading, stays and becomes the rail pictogram.
const useModuleHeader = (children: ReactNode) => {
  const { expanded } = useRightPanel()

  return { rail: !expanded, railChild: Children.toArray(children)[0] }
}

export default useModuleHeader
